var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTumorealseno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.7 42.3",
    style: {
      enableBackground: "new 0 0 23.7 42.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_20053",
    transform: "translate(-758.978 -780.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11524",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M777.4,786.7 c0,0-2.1,7.5-5.3,12.3s-11.9,15-11.9,15l4.1,6.6c0,0,7.7-9.9,11.9-17.5s4.4-9.9,3.9-13.7s-3.1-8.3-9.3-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11525",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M767,805.7 c-0.5-0.9-1.1-1.8-1.5-2.6c-4.2-7.6-4.4-9.9-3.9-13.7s3.1-8.3,9.3-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11526",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M774.7,805.7 c3.3,4.2,6.8,8.2,6.8,8.2l-4.1,6.6c0,0-3.2-4-6.5-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11527",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M764.3,786.7 c0,0,2.1,7.5,5.3,12.3c0.4,0.5,0.8,1.1,1.3,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11528",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M765.5,790.4c0,0,1-4.9,5.4-4.9 c2.6,0,4.8,1.8,5.4,4.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumorealseno);
export default __webpack_public_path__ + "static/media/Tumorealseno.4ba818d00cc45113715c1453831fbb2f.svg";
export { ForwardRef as ReactComponent };